import {
  Box,
  Container,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import TwitterIcon from "@mui/icons-material/Twitter";
import EmailIcon from "@mui/icons-material/Email";
import TelegramIcon from "@mui/icons-material/Telegram";
import {Link} from "react-router-dom"

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: " #1C1B2D ",
        height: "20%",
      }}
    >
      <Container maxWidth="xl" sx={{ pt: "4%", pb: "4%" }}>
        <Grid container>
          <Grid
            item
            xs={12}
            md={3}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Typography color="#fff" fontWeight="bold" fontSize="20px">
              LANDCOIN
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={5}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Stack color="#fff">
              <Typography fontWeight="bold">Quick Links</Typography>
              <Link to="/account/BuysMade"><Typography>Transact</Typography></Link>
              <Link to="/list"><Typography>List Property</Typography></Link>
              <Link to="/search"><Typography>Search</Typography></Link>
            </Stack>
          </Grid>
          <Grid item xs={12} md={4}>
            <Stack>
              <IconButton>
                <a href="https://twitter.com/TheeLandCoin"><TwitterIcon sx={{ color: "#fff" }} /></a>
              </IconButton>
              <IconButton>
                <a href="mailto:collinskoechck34@gmail.com" ><EmailIcon sx={{ color: "#fff" }} /></a>
              </IconButton>
              <IconButton>
                <a href="https://t.me/+BPVdL7fbWJ43MmQ0"><TelegramIcon sx={{ color: "#fff" }} /></a>
              </IconButton>
            </Stack>
          </Grid>
          <Grid item xs={12} md={1}></Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
